import { regions } from '@/misc/constants';

export default function getCurrencyByRegion(regionCode) {
  const region = regions.find((region) => region.isoCountry === regionCode);

  return region ? region.isoCurrency : null;
}
